import { useQuery } from "@tanstack/react-query";
import { fetchEngagementBlueprint } from "PFCore/services/engagement_blueprints";
import { EngagementBlueprint, Id } from "PFTypes";
import { QueryOptions } from "PFTypes/request_options";

import { engagementBlueprintsKeys } from "./query_keys";

export const useEngagementBlueprint = (id: Id, options: QueryOptions<EngagementBlueprint> = {}) =>
  useQuery({
    queryKey: engagementBlueprintsKeys.single(id),
    queryFn: () => fetchEngagementBlueprint(id),
    ...options
  });
